<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocfmf"><a class="xref" href="#/chiheggie0007#abbrs">List of Abbreviations</a></p>
<p class="tocf"><a class="xref" href="#/chiheggie0008#ch01"><span class="sm">ONE</span> / Introduction: Higher and Colder</a></p>
<p class="toc"><a class="xref" href="#/chiheggie0009#ch02"><span class="sm">TWO</span> / Gasping Lungs</a></p>
<p class="toc"><a class="xref" href="#/chiheggie0010#ch03"><span class="sm">THREE</span> / Frozen Fields</a></p>
<p class="toc"><a class="xref" href="#/chiheggie0011#ch04"><span class="sm">FOUR</span> / Local Knowledge</a></p>
<p class="toc"><a class="xref" href="#/chiheggie0012#ch05"><span class="sm">FIVE</span> / Blood on the Mountain</a></p>
<p class="toc"><a class="xref" href="#/chiheggie0013#ch06"><span class="sm">SIX</span> / Conclusion: Death and Other Frontiers</a></p>
<p class="tocbmf"><a class="xref" href="#/chiheggie0014#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chiheggie0015#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chiheggie0016#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chiheggie0017#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-heggie-0006.vue?5e4a24cc